import React from 'react';
import { Compass, Users, HeartHandshake, Home } from 'lucide-react';
export function SolutionSection() {
  const pillars = [{
    icon: <Compass className="w-8 h-8 text-celeste" data-id="element-231" />,
    title: 'Orientación inicial',
    text: 'Te ayudamos a entender el primer paso de forma clara y confidencial.'
  }, {
    icon: <Users className="w-8 h-8 text-celeste" data-id="element-232" />,
    title: 'Acompañamiento profesional',
    text: 'Contamos con un equipo multidisciplinario para apoyar el proceso.'
  }, {
    icon: <HeartHandshake className="w-8 h-8 text-celeste" data-id="element-233" />,
    title: 'Apoyo familiar',
    text: 'La familia también necesita guía, contención y orientación.'
  }, {
    icon: <Home className="w-8 h-8 text-celeste" data-id="element-234" />,
    title: 'Entorno seguro',
    text: 'Nuestras sedes cuentan con espacios pensados para favorecer el bienestar emocional.'
  }];
  return <section id="tratamiento" className="py-16 md:py-24 bg-white" data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-238">
            Un espacio de apoyo, orientación y rehabilitación
          </h2>
          <p className="text-lg text-gray-600" data-id="element-239">
            En Evolución Chile entregamos orientación inicial y acompañamiento
            para personas que enfrentan dependencia a drogas y alcohol, ayudando
            también a sus familias a comprender los próximos pasos con mayor
            claridad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-240">
          {pillars.map((pillar, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-2xl bg-graySoft/50 hover:bg-graySoft transition-colors" data-id="element-241">
              <div className="w-16 h-16 bg-white rounded-full shadow-sm flex items-center justify-center mb-6" data-id="element-242">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-semibold text-azul mb-3" data-id="element-243">
                {pillar.title}
              </h3>
              <p className="text-gray-600" data-id="element-244">{pillar.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}